import {getRequest, postRequest} from "../../../middlewares/api/actions";
import {
  getCategorySchemeUrl,
  getCodelistUrl,
  getCompareItemsForFileUrl,
  getCompareItemsUrl,
  getConceptSchemeUrl,
  getCsvTablePreviewUrl,
  getPaginatedCodelistUrl,
  getUploadFileOnServerUrl,
  getXmlArtefactPreviewUrl,
  getXmlCodelistPreviewUrl
} from "../../../constants/urls";
import {
  COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CATEGORY_SCHEME,
  COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST,
  COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV,
  COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB
} from "./reducer";
import moment from "moment";

export const COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CHANGE = 'COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CHANGE';
export const COMPARE_ITEM_SCHEMES_FORMAT_CHANGE = 'COMPARE_ITEM_SCHEMES_FORMAT_CHANGE';
export const COMPARE_ITEM_SCHEMES_CSV_PROPS_CHANGE = 'COMPARE_ITEM_SCHEMES_CSV_PROPS_CHANGE';

export const COMPARE_ITEM_SCHEMES_FILE_SET = 'COMPARE_ITEM_SCHEMES_FILE_SET';

export const COMPARE_ITEM_SCHEMES_ARTEFACTS_SHOW = 'COMPARE_ITEM_SCHEMES_ARTEFACTS_SHOW';
export const COMPARE_ITEM_SCHEMES_ARTEFACTS_HIDE = 'COMPARE_ITEM_SCHEMES_ARTEFACTS_HIDE';
export const COMPARE_ITEM_SCHEMES_ARTEFACTS_READ = 'COMPARE_ITEM_SCHEMES_ARTEFACTS_READ';
export const COMPARE_ITEM_SCHEMES_ARTEFACT_SET = 'COMPARE_ITEM_SCHEMES_ARTEFACT_SET';
export const COMPARE_ITEM_SCHEMES_ARTEFACT_UNSET = 'COMPARE_ITEM_SCHEMES_ARTEFACT_UNSET';

export const COMPARE_ITEM_SCHEMES_COMPARE_READ = 'COMPARE_ITEM_SCHEMES_COMPARE_READ';
export const COMPARE_ITEM_SCHEMES_COMPARE_HIDE = 'COMPARE_ITEM_SCHEMES_COMPARE_HIDE';
export const COMPARE_ITEM_SCHEMES_COMPARE_DOWNLOAD = 'COMPARE_ITEM_SCHEMES_COMPARE_DOWNLOAD';

export const COMPARE_ITEM_SCHEMES_XML_PREVIEW_SHOW = 'COMPARE_ITEM_SCHEMES_XML_PREVIEW_SHOW';
export const COMPARE_ITEM_SCHEMES_XML_PREVIEW_READ = 'COMPARE_ITEM_SCHEMES_XML_PREVIEW_READ';
export const COMPARE_ITEM_SCHEMES_XML_PREVIEW_PARAMS_UPDATE = 'COMPARE_ITEM_SCHEMES_XML_PREVIEW_PARAMS_UPDATE';
export const COMPARE_ITEM_SCHEMES_XML_PREVIEW_LANG_CHANGE = 'COMPARE_ITEM_SCHEMES_XML_PREVIEW_LANG_CHANGE';
export const COMPARE_ITEM_SCHEMES_XML_PREVIEW_PAGE_READ = 'COMPARE_ITEM_SCHEMES_XML_PREVIEW_PAGE_READ';

export const COMPARE_ITEM_SCHEMES_PREVIEW_HIDE = 'COMPARE_ITEM_SCHEMES_PREVIEW_HIDE';

export const COMPARE_ITEM_SCHEMES_CSV_PREVIEW_SHOW = 'COMPARE_ITEM_SCHEMES_CSV_PREVIEW_SHOW';

export const COMPARE_ITEM_SCHEMES_CSV_FILE_UPLOAD = 'COMPARE_ITEM_SCHEMES_CSV_FILE_UPLOAD';
export const COMPARE_ITEM_SCHEMES_CSV_PAGE_READ = 'COMPARE_ITEM_SCHEMES_CSV_PAGE_READ';

export const changeCompareItemSchemesArtefactType = artefactType => ({
  type: COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CHANGE,
  artefactType
});

export const changeCompareItemSchemesFormat = (isSource, format, lang) => ({
  type: COMPARE_ITEM_SCHEMES_FORMAT_CHANGE,
  isSource,
  format,
  lang
});

export const changeCompareItemSchemesCsvProps = (isSource, fields) => ({
  type: COMPARE_ITEM_SCHEMES_CSV_PROPS_CHANGE,
  isSource,
  fields
});

export const setCompareItemSchemesFile = (isSource, file) => ({
  type: COMPARE_ITEM_SCHEMES_FILE_SET,
  isSource,
  file
});

export const showCompareItemSchemesArtefacts = isSource => ({
  type: COMPARE_ITEM_SCHEMES_ARTEFACTS_SHOW,
  isSource
});

export const hideCompareItemSchemesArtefacts = () => ({
  type: COMPARE_ITEM_SCHEMES_ARTEFACTS_HIDE
});

export const readCompareItemSchemesArtefacts = artefactType => getRequest(
  COMPARE_ITEM_SCHEMES_ARTEFACTS_READ,
  artefactType === COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST
    ? getCodelistUrl()
    : (artefactType === COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CATEGORY_SCHEME
      ? getCategorySchemeUrl()
      : getConceptSchemeUrl()
    )
);

export const setCompareItemSchemesArtefact = artefactTriplet => ({
  type: COMPARE_ITEM_SCHEMES_ARTEFACT_SET,
  artefactTriplet
});

export const unsetCompareItemSchemesArtefact = isSource => ({
  type: COMPARE_ITEM_SCHEMES_ARTEFACT_UNSET,
  isSource
});

export const readCompareItemSchemesCompare = (artefactType, source, sourceFormat, sourceCsvProps, target, targetFormat, targetCsvProps) => {

  let fileFormData = new FormData();
  if (sourceFormat !== COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB) {
    fileFormData.append('files', source);
  }
  if (targetFormat !== COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB) {
    fileFormData.append('files', target);
  }
  if (sourceFormat === COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV) {
    fileFormData.append('customDataFirst', JSON.stringify(sourceCsvProps));
  }
  if (targetFormat === COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV) {
    fileFormData.append('customDataSecond', JSON.stringify(targetCsvProps));
  }

  return postRequest(
    COMPARE_ITEM_SCHEMES_COMPARE_READ,
    getCompareItemsUrl(
      artefactType,
      sourceFormat === COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB ? source : null,
      targetFormat === COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB ? target : null
    ),
    fileFormData
  )
};

export const hideCompareItemSchemesCompare = () => ({
  type: COMPARE_ITEM_SCHEMES_COMPARE_HIDE
});

export const downloadCompareItemSchemesCompare = (artefactType, lang, source, sourceFormat, sourceCsvProps, target, targetFormat, targetCsvProps) => {

  let fileFormData = new FormData();
  if (sourceFormat !== COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB) {
    fileFormData.append('files', source);
  }
  if (targetFormat !== COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB) {
    fileFormData.append('files', target);
  }
  if (sourceFormat === COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV) {
    fileFormData.append('customDataFirst', JSON.stringify(sourceCsvProps));
  }
  if (targetFormat === COMPARE_ITEM_SCHEMES_FORMAT_TYPE_CSV) {
    fileFormData.append('customDataSecond', JSON.stringify(targetCsvProps));
  }

  const currDate = moment().format('YYYY-MM-DD_HH-mm-ss');

  const fileSave = {
    name: `CompareItemSchemes_${currDate}.txt`,
    type: "text/plain;charset=utf-8"
  };

  return {
    ...postRequest(
      COMPARE_ITEM_SCHEMES_COMPARE_DOWNLOAD,
      getCompareItemsForFileUrl(
        artefactType,
        lang,
        sourceFormat === COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB ? source : null,
        targetFormat === COMPARE_ITEM_SCHEMES_FORMAT_TYPE_MSDB ? target : null
      ),
      fileFormData
    ),
    fileSave
  }
};

export const showCompareItemSchemesXmlPreview = isSource => ({
  type: COMPARE_ITEM_SCHEMES_XML_PREVIEW_SHOW,
  isSource
});

export const readCompareItemSchemesXmlPreview = (artefactType, file, lang) => {
  let fileFormData = new FormData();
  fileFormData.append('file', file);


  return postRequest(
    COMPARE_ITEM_SCHEMES_XML_PREVIEW_READ,
    artefactType === COMPARE_ITEM_SCHEMES_ARTEFACT_TYPE_CODELIST
      ? getXmlCodelistPreviewUrl(lang)
      : getXmlArtefactPreviewUrl(artefactType),
    fileFormData
  )
};


export const updateCompareItemSchemesXmlPreviewParams = params => ({
  type: COMPARE_ITEM_SCHEMES_XML_PREVIEW_PARAMS_UPDATE,
  params
});

export const changeCompareItemSchemesXmlPreviewLang = lang => ({
  type: COMPARE_ITEM_SCHEMES_XML_PREVIEW_LANG_CHANGE,
  lang
});

export const readCompareItemSchemesXmlPreviewPage =
  (triplet, lang, pageNum, pageSize, searchText, filters, sortCol, sortByDesc, rebuildDb) => ({
    ...postRequest(
      COMPARE_ITEM_SCHEMES_XML_PREVIEW_PAGE_READ,
      getPaginatedCodelistUrl(),
      {
        id: triplet && triplet.id ? triplet.id : undefined,
        agencyID: triplet && triplet.agencyID ? triplet.agencyID : undefined,
        version: triplet && triplet.version ? triplet.version : undefined,
        lang: lang ? lang : undefined,
        pageNum: pageNum ? pageNum : undefined,
        pageSize: pageSize ? pageSize : undefined,
        allSearch: searchText ? searchText : undefined,
        codeSearch: filters && filters.id ? filters.id : undefined,
        nameSearch: filters && filters.name ? filters.name : undefined,
        parentSearch: filters && filters.parent ? filters.parent : undefined,
        sortColumn: sortCol ? sortCol : undefined,
        sortDesc: sortByDesc ? sortByDesc : undefined,
        rebuildDb
      }
    )
  });

export const hideCompareItemSchemesPreview = () => ({
  type: COMPARE_ITEM_SCHEMES_PREVIEW_HIDE
});

export const showCompareItemSchemesCsvPreview = isSource => ({
  type: COMPARE_ITEM_SCHEMES_CSV_PREVIEW_SHOW,
  isSource
});

export const uploadCompareItemSchemesCsvFile = file => {
  let fileFormData = new FormData();
  fileFormData.append('file', file);

  return postRequest(
    COMPARE_ITEM_SCHEMES_CSV_FILE_UPLOAD,
    getUploadFileOnServerUrl(),
    fileFormData
  );
};

export const readCompareItemSchemesCsvPage =
  (pageNum, pageSize, filterTable, sortCols, sortByDesc, separator, delimiter, hasHeader, filePath) => postRequest(
    COMPARE_ITEM_SCHEMES_CSV_PAGE_READ,
    getCsvTablePreviewUrl(separator, delimiter, hasHeader, filePath, null, null),
    {
      PageNum: pageNum,
      PageSize: pageSize,
      FilterTable: filterTable,
      SortCols: sortCols,
      SortByDesc: sortByDesc,
    }
  );


// WEBPACK FOOTER //
// ./src/scenes/utilities/compare-item-schemes/actions.js